export const pagesState = {
  pagesFormStatus: false,
  pagesIsEdit: false,
  pagesSelectedForEdit: null,
  pagePublishRequest:false
};